<ng-container *ngFor="let action of notificationTypeActions">
  <ng-container [ngSwitch]="action.actionType">
    <a *ngSwitchCase="'Internal'" [routerLink]="[action.actionValue, notificationId]" (click)="actionTriggered($event)" [id]="getLinkId(action.displayText)">{{ action.displayText }}</a>
  </ng-container>
</ng-container>